// extracted by mini-css-extract-plugin
module.exports = {"feature_card":"FeatureCard_feature_card__437MB","image":"FeatureCard_image__KvEuU","title":"FeatureCard_title__6pS3k","fade_in":"FeatureCard_fade_in__Iq23o"};